import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';
import { HomeService } from '../home.service';
import { Subscription } from 'rxjs';
import { MsgCenterService } from '../navbar/msg-center/msg-center.service';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { SharedsService } from 'src/app/shareds/shareds.service';
import { SocketService } from '../socket.service';
import { TranslateService } from '@ngx-translate/core';
import { AppComponent } from 'src/app/app.component';
import { DatePipe } from '@angular/common';
import { NlpService } from 'src/app/shareds/nlp.service';
import {EnvironmentService} from '../../../environment.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  chatBotDetails: any = [];
  socketSubscription: Subscription;
  isAppEnabled = true;
  appName: string;
  appId: string;
  currentRoute: string;
  dashboardPrefix;
  routeSubscripion: Subscription;
  appAgentHandover = false;
  userAppNames: any;
  userApps = [];
  selectedApp;
  userType: string;
  userId: string;
  config: any = {
    displayKey: 'appName',
    search: true,
    height: 'auto',
    placeholder: 'Select',
    limitTo: 10,
    moreText: 'more',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search',
    searchOnKey: 'appName'
  };

  @Output() messageEvent = new EventEmitter<string>();
  width: any; // width-true: Sidebar open, false - minimized
  screenWidth: number;
  subscription: Subscription;
  translatorLanguage: string;
  subscriptionStatus: boolean = false;
  subscriptionEndDate: any;
  subscriptionTitle: any = 'Subscription Cancelled | Deleting on';
  subscriptionPopup: any = 'Your account details and messages will be deleted on [Last Day of Billing Cycle].';
  dateFormat: any;
  projectDetails: any;
  apiUrl = '';
  connectorUrl = '';
  chatWindow = false;
  constructor(
    private readonly router: Router,
    private readonly homeService: HomeService,
    private readonly msgCenterService: MsgCenterService,
    private readonly sharedService: SharedsService,
    private readonly socket: SocketService,
    public translate: TranslateService,
    public readonly datePipe: DatePipe,
    private readonly appComponet: AppComponent,
    private readonly envService: EnvironmentService,
    private readonly nlpService: NlpService) {
    this.apiUrl = this.envService.read('apiUrl');
    this.connectorUrl = this.envService.read('connectorUrl');
    this.translatorLanguage = localStorage.getItem('Language');
    this.translate.setDefaultLang('en');
    const theme = localStorage.getItem('theme');
    this.appComponet.loadStyle(theme);
    this.translate.use(
      this.translatorLanguage ? this.translatorLanguage : 'en',
    );
    this.subscription = this.homeService.getMessage().subscribe((data) => {
      if (data.type === 'sideBar') {
        this.width = data.message;
      }
    });
    this.msgCenterService.menuToggle.subscribe(res => {
      this.toogleWidth('toggle');
    });
  }

  ngOnInit() {
    this.fetchProjectDetails();
    this.homeService.subscriptionRevoked.subscribe(data => {
      if (data === true) {
        this.fetchProjectDetails();
      }
    })
    const userData = JSON.parse(localStorage.getItem('user')) ?? {};
    this.dateFormat = userData?.dateFormat ? userData.dateFormat : 'MM/dd/YYYY';
    this.appName = JSON.parse(localStorage.getItem('user')).appname;
    this.appId = JSON.parse(localStorage.getItem('user')).appid;
    this.appAgentHandover = JSON.parse(localStorage.getItem('user'))?.appSettings?.conversations?.agent_handover ?? false;
    this.initResponsiveElements();
    let width: any = localStorage.getItem('sideBarOpen');
    width = width ? (width === 'true') : true;
    this.width = width;
    this.homeService.sendMessage({
      type: 'sideBar',
      message: this.width
    });
    this.isAppEnabled = JSON.parse(localStorage.getItem('user'))?.appSettings?.projectDetail?.is_app_enabled ?? true;
    this.dashboardPrefix = environment.dashboardPrefix === '/' ? '' : environment.dashboardPrefix;
    this.currentRoute = this.router.url;
    this.routeSubscripion = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        this.currentRoute = this.router.url;
      }
    });
    this.userType = JSON.parse(localStorage.getItem('user')).user_type;
    this.userId = JSON.parse(localStorage.getItem('user'))?.user_id ?? '';
    const appNames = localStorage.getItem('allowedAppIds') ? localStorage.getItem('allowedAppIds') : '';
    this.userAppNames = appNames.split(',');
    const args = {
      userappnames: []
    };
    args.userappnames = this.userAppNames;

    this.msgCenterService.getAppNames(args).subscribe((result => {
      this.userApps = result.info;
      this.userApps = this.userApps.filter(app => {
        return (app.appid !== this.appId);
      });
      this.config = {
        displayKey: 'appName',
        search: true,
        height: 'auto',
        placeholder: this.appName,
        limitTo: this.userApps.length,
        moreText: 'more',
        noResultsFound: 'No results found!',
        searchPlaceholder: 'Search',
        searchOnKey: 'appName'
      };
    }));
    this.socketSubscription = this.socket.getApplicationStatus().subscribe((message) => {
      if (message.appid === this.appId) {
        this.isAppEnabled = message.is_app_enabled;
      } else { this.isAppEnabled = true; }
    });
  }

  toogleWidth(type: string) {
    if (type === 'toggle') {
      this.width = !this.width;
      localStorage.setItem('sideBarOpen', this.width.toString());
      this.homeService.sendMessage({
        type: 'sideBar',
        message: this.width
      });
    } else if (!(this.width.toString() === localStorage.getItem('sideBarOpen') ? localStorage.getItem('sideBarOpen').toString() : '')) {
      localStorage.setItem('sideBarOpen', this.width.toString());
      this.homeService.sendMessage({
        type: 'sideBar',
        message: this.width
      });
    }
    this.messageEvent.emit(this.width);
  }

  changeuserApp() {
    const args = { appid: '', usertype: '', userid: '', lang: '' };
    const lang = localStorage.getItem('Language');
    args.appid = this.selectedApp.appid;
    args.usertype = this.userType;
    args.userid = this.userId;
    args.lang = lang;
    this.msgCenterService.getAppDetails(args).subscribe(result => {
      const local_data = JSON.parse(localStorage.getItem('user'));
      const theme = result.user_data?.['appSettings']?.['projectDetail']?.theme;

      localStorage.setItem('theme', theme || 'black-style.css');
      this.hideChatBot();
      if (result.user_data.roles) {
        local_data.roles.menu_tab = result.user_data?.roles?.menu_tab;
      }
      if (result.user_data.appid) {
        local_data.roles.appid = result.user_data?.appid;
        local_data.appid = result.user_data?.appid;
      }
      if (result.user_data.appname) {
        local_data.roles.appname = result.user_data.appname;
        local_data.appname = result.user_data.appname;
      }
      if (result.user_data.channels) {
        local_data.channels = result.user_data.channels;
      }
      if (result.user_data.appSettings) {
        local_data.appSettings = result.user_data.appSettings;
        if (result.user_data.appSettings.AI_technology) {
          local_data.AI_technology = result.user_data.appSettings.AI_technology;
        } else {
          local_data.AI_technology = '';
        }
      }
      if (result.user_data.wabaAccounts) {
        local_data.wabaAccounts = result.user_data.wabaAccounts;
      }
      localStorage.setItem('companyNameLogoUrl', JSON.stringify(result.user_data.companyNameLogoUrl));
      localStorage.setItem('user', JSON.stringify(local_data));
      this.sharedService.appId = result?.user_data?.appid ?? '';
      const redirectUrl = environment.dashboardPrefix + local_data.roles.menu_tab[0].path;
      this.router.navigate([redirectUrl]);
      setTimeout(() => {
        if (redirectUrl === this.router.url) {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/dashboard/overviews']);
          });
          // after setting modified menu_items calling side bar function to update menu tab.
          this.homeService.sendMessage({
            type: 'menutab'
          });

          this.homeService.sendMessage({
            type: 'profile'
          });
        } else {
          // after setting modified menu_items calling side bar function to update menu tab.
          this.homeService.sendMessage({
            type: 'menutab'
          });

          this.homeService.sendMessage({
            type: 'profile'
          });
        }
      }, 1000);
    });
  }
  hideChatBot() {
    const w = document.querySelector('#columna_derecha');
    if ((window as any).UIBconfig) {
      delete (window as any).UIBconfig;
    }

// Option 2: reset to an empty object
    //  (window as any).UIBconfig = {};
    if (w) {
      (w as HTMLElement).remove();
    }
  }
  initResponsiveElements() {
    this.screenWidth = window.screen.width;
    if (this.screenWidth < 1120) {
      this.width = false;
    } else {
      this.width = true;
    }
    this.toogleWidth('resize');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.screenWidth = window.innerWidth;
    this.checkScreenWidth();
  }

  // A method to perform actions based on the screen width
  checkScreenWidth(): void {
    if (this.screenWidth < 1120) {
      this.width = false;
    } else {
      this.width = true;
    }
    this.toogleWidth('resize');
  }

  setBillingCycleEndDate() {
    const createdDate = this.projectDetails?.created_on;
    const unsubscribedDate = new Date(
      this.projectDetails?.subscription_deleted_on,
    );
    console.log(
      'this.dateFormat',
      this.dateFormat,
      this.projectDetails?.nextBillingDate,
    );
    if (this.projectDetails?.nextBillingDate) {
      this.subscriptionEndDate = this.projectDetails?.nextBillingDate;
    } else {
      this.subscriptionEndDate = this.calculateDashboardAccessEndDate();
    }
    this.subscriptionPopup = this.subscriptionPopup.replace(
      '[Last Day of Billing Cycle]',
      this.datePipe.transform(this.subscriptionEndDate, this.dateFormat) || '-',
    );
  }

  calculateDashboardAccessEndDate() {
      let date;
      const createdOn = this.projectDetails?.created_on;
      const freeTrail = 14;
      const created_on = new Date(createdOn);
      const subscription_date = new Date(this.projectDetails?.subscription_date);
      const createdPlustrialDays = new Date(created_on.getTime() + freeTrail * 24 * 60 * 60 * 1000);
      console.log("created_on + 14 days:", createdPlustrialDays.toDateString());
      if (createdPlustrialDays > subscription_date) {
        console.log("created_on + 14 days is greater than subscription_date");
        date = subscription_date;
      } else {
        console.log("created_on + 14 days is NOT greater than subscription_date");
        date = createdPlustrialDays;
      }
      const year = date.getUTCFullYear();
      const month = date.getUTCMonth();
      const day = date.getUTCDate();
      date = new Date(Date.UTC(year, month + 1, day, created_on.getUTCHours(), created_on.getUTCMinutes(), created_on.getUTCSeconds()));
      date = date.toDateString();
      return date;
  }

  fetchProjectDetails() {
    this.nlpService.getAppCredentials().subscribe(
      (res) => {
        if (res.status === 200) {
          const userData = JSON.parse(localStorage.getItem('user'));
          this.projectDetails = res.info ?? {};
          if(this.projectDetails.trial_expire && this.projectDetails.trail_end_date) {
          userData.trial_expire = this.projectDetails.trial_expire;
          userData.trail_end_date = this.projectDetails.trail_end_date;
          localStorage.setItem('user', JSON.stringify(userData));
          }
          this.subscriptionStatus = this.projectDetails?.subscriptionRevoked ?? false;
          if (this.projectDetails?.subscription_deleted_on) {
            this.setBillingCycleEndDate();
          }
          this.chatWidget(res.info);
        }
      },
      (err) => {}
    );
  }

  chatWidget(data) {
    console.log('hello data', window.UIBconfig);
    if (window.UIBconfig) {
      this.chatWindow = true;
      return;
    } else {
      this.chatWindow = false;
    }
    console.log('hello data', window.UIBconfig);
    window.UIBconfig = null;
    const userData = localStorage.getItem('user')
      ? JSON.parse(localStorage.getItem('user'))
      : {};
    console.log('userData', userData);
    const botId = data.Bot_ID;
    console.log(botId);
    this.chatBotDetails = [];
    this.chatBotDetails = botId?.filter(
      (item) => item.key === 'unifiedaitestagent',
    );
    if (!this.chatBotDetails || this.chatBotDetails.length === 0) {
      this.chatWindow = false;
      return;
    } else {
      this.chatWindow = true;
    }
    console.log("chatBotDetails",this.chatBotDetails);
    window.UIBconfig = {
      apiURL: this.connectorUrl,
      appId: this.chatBotDetails[0].appID, // UIb demo App Id
      botId: this.chatBotDetails[0].value, // UIb demo uib  Bot Id
      // apiURL: 'http://192.168.2.3:7111/',
      // appId: 'e760d317-7bce-4bb1-ab0a-7c1521d3efca',
      // botId: 'a5a04d0e-36f7-45da-bcd8-2a6a3b79795b',
      userId: userData.user_name, // Unique id of the user
      historyApiURL: this.apiUrl + '/',
      settings: {
        chatBotPosition: 'bottom-right', // top-left,top-right,bottom-left,bottom-right
        botIcon: 'https://chat.uib.ai/assets/img/uib.png', // Bot Icon Image
        botName: 'UnifiedAI Test Agent', // Bot name
        chatText: 'Chat with us now!', // Widget Label
        chatPlaceholder: 'Try typing here...', // Chat textbox placeholder
        browserUnsupported:
          'The chat widget is not compatible with this browser.', //BrowserUnsupported Warning message
        browserVersionUnsupported:
          'The current version of the browser is required for this application. Please update your browser.', // Browser version Unsupported warning message
        chatPreview: 'off', // Chat preview- on/off
        showMinimizedLogo: false, // if preview is on, the chat icon will be show when closed
        showMinimizedText: false, // if preview is on, the chat text will be show when closed
        attachment: true, // true or false to enable/disable attachment sending
        activeChatPreviewMsg: 'Questions? I can help.', // Active chat preview messages
        inactiveChatPreviewMsg: 'z Z z ... I am currently unavailable.', // Inactive chat preview message
        // welcomeMessage: 'Hi, what can I help you with?<button>Services</button><button>Enquiries</button><button>Other</button>',
        offHoursPreview: false, // preview will not be displayed when page is initially loaded if set as false
        chatWorkingHours: {
          workingTimeStatus: false, // Time status - true/false ( please set chatPreview = on while workingTimeStatus is set as true")
          timeZone: 'Asia/Singapore', // refer URL:https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
          workingTime: [
            {
              dayName: 'Sunday', // Day name - Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday
              workingStatus: 'off', // working Status - on/off
              time: null, // time Format - null/ eg:{startTime:'9:00 AM',endTime:'4:00 PM'}
            },
            {
              dayName: 'Monday',
              workingStatus: 'on', // working Status - on/off
              time: { startTime: '9:00 AM', endTime: '4:00 PM' },
            },
            {
              dayName: 'Tuesday',
              workingStatus: 'on', // working Status - on/off
              time: { startTime: '9:00 AM', endTime: '4:00 PM' },
            },
            {
              dayName: 'Wednesday',
              workingStatus: 'off', // working Status - on/off
              time: { startTime: '9:00 AM', endTime: '4:00 PM' },
            },
            {
              dayName: 'Thursday',
              workingStatus: 'on', // working Status - on/off
              time: { startTime: '9:00 AM', endTime: '4:00 PM' },
            },
            {
              dayName: 'Friday',
              workingStatus: 'on', // working Status - on/off
              time: { startTime: '9:00 AM', endTime: '4:00 PM' },
            },
            {
              dayName: 'Saturday',
              workingStatus: 'off', // working Status - on/off
              time: null,
            },
          ],
        },
        customizeSendButton: {
          sendButtonCustomizeAllow: true, // true/false, if false - Default button is active
          sendButtonCustomizeHTML:
            '<button style="border-radius: 50px;height:40px;margin: 10px;background:rgb(17, 202, 151);color:white;"><svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill= "white" d="M17,12L12,17V14H8V10H12V7L17,12M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15Z" /></svg></button>', // Send Button html format. we are using svg button, You can replace the button tag and add image(jpg/png/icon image/svg) using img tag.
          // sendButtonCustomizeHTML:'<img src ="https://uib.ai/assets/images/uib.png" height="30" width="30" style ="float:right;margin-top: 20px;"/>',
          sendButtonAreaWidth: '82px', //Send button Area width, eg:72px
        },
        botNameColor: '#747474', //Bot name color
        inactiveBotNameColor: 'white', // Inactive Bot Name color
        closeButtonColor: '#747474', // close Button icon color - (X)
        inactiveChatBotHeaderBackgroundColor: 'gray', // Inactive chat bot header background color
        activeChatBotHeaderBackgroundColor: 'white', // Active chat bot header background color
        widgetChatIcon: false,
        //chatBotBackgroundColor:"lightgray", // chatBot Background color
        //widgetBackground:'green',  // widget background
        //chatTextColor:'red', // widget text color
        //userChatBackgroundColor:"#1799e4", // User chat message background color
        //userChatLabelColor:'white', // User chat message color
        //botChatBackgroundColor:"green", // Bot chat message background color
        //botChatLabelColor:'red', // Bot chat message  color
        //buttonBackgroundColor: '', // background color of button
        //buttonTextColor: '', // text color of button
        //buttonHoverBackgroundColor: '',  // background color of button while hovering
        //buttonHovertextColor: '', // text color of button  while hovering
        //buttonBorderColor: '', // border color of button
        //buttonHoverBorderColor: '', // border color of button  while hovering
        //fontFamily: 'Roboto', // Roboto, Noto Sans, Lato, Montserrat, Radio Canada (https://fonts.google.com/)
      },
    };
    window.UIBChat.init();
  }

  chatOpen() {
    window.UIBChat.chatOpen();
  }
}
